import i18n from 'i18next';
const MINIMUM_LENGTH = 12;
const COMMON_PASSWORDS = new Set([
    'password1234',
    'password12345',
    'password123456',
    '123456789012',
    'qwerty123456',
    'qwertyuiop12',
    'administrator',
    'administrator1',
    'changeme1234',
    'passw0rd1234',
    'welcome12345',
    'newlumen1234',
    'newlumen12345',
]);
/**
 * Validates a password against the policy. Returns an error message
 * for the first failed rule, or null if the password is valid.
 * Mirrors the backend PasswordPolicy.Validate() rules.
 */
export function validatePassword(password) {
    if (!password) {
        return i18n.t('password.required');
    }
    if (password.length < MINIMUM_LENGTH) {
        return i18n.t('password.minLength', { min: MINIMUM_LENGTH });
    }
    if (!/[A-Z]/.test(password)) {
        return i18n.t('password.needsUppercase');
    }
    if (!/[a-z]/.test(password)) {
        return i18n.t('password.needsLowercase');
    }
    if (!/\d/.test(password)) {
        return i18n.t('password.needsDigit');
    }
    if (COMMON_PASSWORDS.has(password.toLowerCase())) {
        return i18n.t('password.tooCommon');
    }
    return null;
}
